function isPrivateIpv4(hostname: string): boolean {
  const parts = hostname.split('.').map(part => Number(part))
  if (parts.length !== 4 || parts.some(part => Number.isNaN(part))) {
    return false
  }

  const [a, b] = parts
  if (a === 10) {
    return true
  }
  if (a === 172 && b >= 16 && b <= 31) {
    return true
  }
  if (a === 192 && b === 168) {
    return true
  }
  if (a === 127) {
    return true
  }
  return false
}

function isPrivateOrLocalHost(hostname: string): boolean {
  const normalized = hostname.toLowerCase()
  if (normalized === 'localhost' || normalized.endsWith('.localhost')) {
    return true
  }
  if (
    normalized === '::1' ||
    normalized.startsWith('fe80:') ||
    normalized.startsWith('fc') ||
    normalized.startsWith('fd')
  ) {
    return true
  }
  return isPrivateIpv4(normalized)
}

export function isValidWebhookUrl(value: string): boolean {
  if (!value?.trim()) {
    return false
  }

  try {
    const url = new URL(value.trim())
    if (url.protocol !== 'https:') {
      return false
    }
    return !isPrivateOrLocalHost(url.hostname)
  } catch {
    return false
  }
}

export function normalizeWebhookUrl(value: string): string {
  try {
    const url = new URL(value.trim())
    return `${url.protocol}//${url.hostname.toLowerCase()}${url.pathname}${url.search}`
  } catch {
    return value.trim().toLowerCase()
  }
}
